import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';

export const Pricing = () => {
  return (
    <section id="pricing" className="py-24 px-4 bg-[#0B0E14] relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-royal-600/10 rounded-full blur-[100px] pointer-events-none"></div>
      
      <div className="max-w-3xl mx-auto relative z-10">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="bg-navy-800/80 backdrop-blur-xl border-2 border-royal-500/30 rounded-[2.5rem] p-8 md:p-16 text-center shadow-[0_0_50px_rgba(37,99,235,0.1)]"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
            Special Financial Year End Pricing
          </h2>
          
          <div className="flex flex-col items-center justify-center mb-10">
            <span className="text-gray-400 text-lg mb-2 font-medium">Normal Price: <span className="line-through">₹16,000 + GST</span></span>
            <div className="text-xs font-bold tracking-widest text-royal-400 uppercase mb-4">Today Only</div>
            <div className="flex items-start justify-center gap-1">
              <span className="text-3xl md:text-4xl font-bold text-white mt-2">₹</span>
              <span className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-400 tracking-tighter">
                3,997
              </span>
            </div>
            <div className="mt-4 inline-block bg-green-500/10 text-green-400 border border-green-500/20 px-4 py-1.5 rounded-full text-sm font-semibold">
              ✔ Lifetime Access
            </div>
          </div>

          <CTAButton text="Upgrade to Silver 2.0 Now" className="w-full md:w-auto min-w-[300px]" />
          <p className="mt-6 text-gray-400 text-sm">Secure, encrypted checkout via FunnelsDone. Instant access.</p>
        </motion.div>
      </div>
    </section>
  );
};